import EventBase from './EventBase'
import EventID from './EventID'


export default class EventPromptMessage extends EventBase {
  /**
   * 提示消息框构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }
  /**
   * 内容
   */
  get Content() {
    return this.Parameter?.[0] || ''
  }
  set Content(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 获取事件ID
   */
  Code = EventID.PromptMessage

  /**
   * 获取描述信息
   */
  /// <returns></returns>
}
